/** Landing (and others) set this before `setActiveView('fabricmarketplace')`; gallery reads once on mount. */
export const SESSION_OPEN_PUBLIC_FABRIC_ID = 'fashdeck_open_public_fabric_id';
